import React from 'react'

import { ArticleCardProps } from './types'

export const ArticleCard: React.FC<ArticleCardProps> = ({ href, ...props }) => (
  <a href={href} {...props} className="article-card" />
)
